module.exports = __webpack_public_path__ + "static/media/  (12).0c33214b.jpg";